import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { resetMe } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/admin/login", { email, password });
      resetMe();
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5F5F5] p-6" data-testid="login-page">
      <div className="w-full max-w-sm bg-white border border-[#E7E5E4] rounded-md p-8">
        <div className="mb-8 text-center">
          <div className="font-display text-2xl tracking-[0.02em] font-semibold" data-testid="login-brand">FLASH</div>
          <p className="text-sm text-[#57534E] mt-1">Sign in to continue</p>
        </div>
        <form onSubmit={submit} className="space-y-4" data-testid="login-form">
          <div className="space-y-1.5">
            <Label htmlFor="email" className="text-xs text-[#57534E]">Email</Label>
            <Input id="email" type="email" required autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" className="h-10" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="password" className="text-xs text-[#57534E]">Password</Label>
            <Input id="password" type="password" required autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" className="h-10" />
          </div>
          <Button type="submit" disabled={loading} data-testid="login-submit-btn" className="w-full h-10 bg-[#1C1917] hover:bg-[#292524] text-white">
            {loading ? "Signing in..." : "Sign in"}
          </Button>
        </form>
      </div>
    </div>
  );
}
